import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/topics", label: "话题广场", end: false },
  { to: "/polls", label: "投票风向", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex w-full items-center gap-4 px-4 py-3 md:px-8 md:py-4">
        <Link to="/" className="flex shrink-0 cursor-pointer items-center gap-2.5" aria-label="爆料看点首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            爆
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              爆料看点
            </span>
            <span className="mt-0.5 font-label text-[11px] tracking-[0.16em] text-foreground-500">
              吃瓜风向站
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="ml-6 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3.5 py-2 font-label text-sm transition-colors ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <Link
            to="/topics"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 font-label text-xs text-foreground-700 transition-colors hover:border-accent-300 hover:bg-accent-50 hover:text-accent-900 sm:flex"
          >
            <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-600">
              <i className="ri-fire-line" aria-hidden="true" />
            </span>
            今日热议 8 条
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 font-label text-sm transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}